import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VMask from './VMask';
import RefundProjectDetail from '../order-detail/refund/refund-project-detail';
import RefundOrderDetail from '../order-detail/refund/refund-order-detail';
import RebookServiceTitle from '../order-detail/rebook-service-title';
export default {
  name: 'widget__servicetitlelist',
  components: {
    'v-mask': VMask,
    RefundProjectDetail: RefundProjectDetail,
    RefundOrderDetail: RefundOrderDetail,
    RebookServiceTitle: RebookServiceTitle
  },
  data: function data() {
    return {
      isShowTop: false,
      isShowBottom: true
    };
  },
  mounted: function mounted() {
    // 先注册滚动事件
    this.$refs.box.addEventListener('scroll', this.scroll);
  },
  props: {
    serviceTitleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    batchRefundRuleDetails: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onClose: {
      type: Function,
      default: function _default() {}
    },
    performanceId: {
      type: Number
    },
    useTime: {
      type: Number,
      default: 0
    },
    showId: {
      type: Number
    },
    isNewPage: {
      type: Boolean
    },
    structureRefund: {
      type: Boolean
    },
    rebookRuleVO: {
      type: Object
    },
    useRebookRuleVO: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShowServiceTitle: function isShowServiceTitle() {
      var hasServiceTitle = this.serviceTitleList && this.serviceTitleList.length > 0;
      return hasServiceTitle;
    }
  },
  methods: {
    // 监听滚动事件
    scroll: function scroll() {
      var _this$$refs$box = this.$refs.box,
        scrollTop = _this$$refs$box.scrollTop,
        clientHeight = _this$$refs$box.clientHeight,
        scrollHeight = _this$$refs$box.scrollHeight;
      if (scrollTop > 20) {
        this.isShowTop = true;
      } else {
        this.isShowTop = false;
      }
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isShowBottom = false;
      } else {
        this.isShowBottom = true;
      }
    } // 先付先抢已下架，为保险先注释，没问题后可删
    // click ( type ) {
    //   if ( type === 6 ) {
    //     this.$emit( 'goFbFgRule' )
    //   }
    // },
  }
};